"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPlayerQuickChat = void 0;
const selectPlayerQuickChat = (playerId) => (state) => state.game.quickChat[playerId];
exports.selectPlayerQuickChat = selectPlayerQuickChat;
